import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-external-bankid-button',
  templateUrl: './external-bankid-button.component.html',
  styleUrls: ['./external-bankid-button.component.scss'],
})
export class ExternalBankidButtonComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
